import { Component, OnInit } from '@angular/core';
import { AuthService, WMAIApiService, AppInformationService } from '../core/services/';
import { ActivatedRoute, Event, Router, RoutesRecognized  } from '@angular/router';

@Component({
  selector: 'app-ssoreturn',
  templateUrl: './ssoreturn.component.html',
  styleUrls: ['./ssoreturn.component.css']
})
export class SsoreturnComponent implements OnInit {
  paramsSubscription: any;
  code: string;
  uuid: string;

  constructor(
    private auth: AuthService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private activedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.activedRoute.queryParams.subscribe(params => {
      if (params['code'] != null) {
        // console.log(params['code'] );
        this.auth.loginIdm(params['code'] );
      }
    });
  }
}

